module.exports = __webpack_public_path__ + "assets/luggage-cart-solid.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/luggage-cart-solid.svg
// module id = 1670
// module chunks = 7